// extracted by mini-css-extract-plugin
export default {"error-box":"styles_error-box__YbTIB","display-text-1":"styles_display-text-1__bq7aX","display-text-2":"styles_display-text-2__7-il4"};